import { Component } from '@angular/core';

@Component({
  selector: 'wp-form-agreement',
  standalone: true,
  templateUrl: './form-agreement.component.html',
  styleUrl: './form-agreement.component.scss',
})
export class FormAgreementComponent {}
